import type { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import DashboardSidebar from './DashboardSidebar';

function DashboardLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="w-full px-4 md:px-8 lg:px-12 pt-24 md:pt-32 pb-16">
        <div className="flex flex-col lg:flex-row gap-6">
          <DashboardSidebar />
          <div className="flex-1 min-w-0">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;